const url = '/commission-types';
const Provider = 'CommissionTypes';
const dbModel = 'CommissionTypes';

export { url, Provider, dbModel };
